import { render } from "./sb-carousel.vue?vue&type=template&id=7cce9d40&ts=true"
import script from "./sb-carousel.ts?vue&type=script&lang=ts"
export * from "./sb-carousel.ts?vue&type=script&lang=ts"

import "./sb-carousel.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/luca/comperioprojects/selfbox_frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__